var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Section1"}},[_vm._v(" Portfolio Coming Soon - in the meantime, "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$emit('contact')}}},[_vm._v("Contact me now")]),_vm._v(" if you think there’s something I can do for you! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }